let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ayM4H")).then(() => parcelRequire('lrWy4'));